import http from '../http'
const API_URL = "municipality"

class municipalityAPI {

  async getAllMunicipality() {
    const response = await http(`${API_URL}`)
    return response
  }

  async getAllUnpaginated() {
    const response = await http(`${API_URL}/all`)
    return response
  }

  async getByDepartment(departmentID) {
    const response = await http(`${API_URL}/show-department/${departmentID}`)
    return response
  }

  async get(ID) {
    const response = await http(`${API_URL}/show/${ID}`)
    return response
  }
 
  
}

export default new municipalityAPI()